import { TxStatus } from "src/constance";
import { popTxStatus, pushTxStatusThunk, updateTxStatus } from "src/redux/components/tx-status-slice";
import store from "src/redux/store";

export function handleEmit(emit, type) {
  const id = store.dispatch(
    pushTxStatusThunk({
      status: TxStatus.WAIT_USER_CONFIRM_TX,
      type,
    })
  );
  let hasTxHash = false;
  try {
    emit.on("transactionHash", (hash) => {
      store.dispatch(updateTxStatus({ id, txHash: hash, status: TxStatus.TX_EXECUTING }));
      hasTxHash = true;
    });
    emit.on("receipt", (receipt) => {
      store.dispatch(updateTxStatus({ id, status: TxStatus.TX_SUCCESS }));
      setTimeout(() => {
        store.dispatch(popTxStatus({ id }));
      }, 15000);
    });
    emit.on("error", (error, receipt) => {
      if (hasTxHash) {
        store.dispatch(updateTxStatus({ id, status: TxStatus.TX_FAILED }));
        setTimeout(() => {
          store.dispatch(popTxStatus({ id }));
        }, 15000);
      } else {
        store.dispatch(popTxStatus({ id }));
      }
    });
  } catch (error) {
    console.error(error);
    store.dispatch(popTxStatus({ id }));
  }
}
